/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ImplementationDetailsQueryVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
}>;


export type ImplementationDetailsQueryGQLType = (
  { __typename?: 'Query' }
  & { implementation: (
    { __typename?: 'Implementation' }
    & Pick<Types.ImplementationGQLType, 'id' | 'name'>
    & { loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<Types.LoanProductGQLType, 'id' | 'slug' | 'name'>
    )>, creditFacilities: Array<(
      { __typename?: 'CreditFacility' }
      & Pick<Types.CreditFacilityGQLType, 'id' | 'slug' | 'name' | 'borrowerOrganizationName'>
    )> }
  ) }
);

export type UpdateImplementationNameMutationVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
  name: Types.Scalars['String'];
}>;


export type UpdateImplementationNameMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateImplementationName: (
    { __typename?: 'Implementation' }
    & Pick<Types.ImplementationGQLType, 'id' | 'name'>
  ) }
);


export const ImplementationDetailsDocumentGQLType = gql`
    query implementationDetails($implementationId: UUID!) {
  implementation(implementationId: $implementationId) {
    id
    name
    loanProducts {
      id
      slug
      name
    }
    creditFacilities {
      id
      slug
      name
      borrowerOrganizationName
    }
  }
}
    `;

/**
 * __useImplementationDetailsQuery__
 *
 * To run a query within a React component, call `useImplementationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImplementationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImplementationDetailsQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useImplementationDetailsQuery(baseOptions: Apollo.QueryHookOptions<ImplementationDetailsQueryGQLType, ImplementationDetailsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImplementationDetailsQueryGQLType, ImplementationDetailsQueryVariablesGQLType>(ImplementationDetailsDocumentGQLType, options);
      }
export function useImplementationDetailsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<ImplementationDetailsQueryGQLType, ImplementationDetailsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImplementationDetailsQueryGQLType, ImplementationDetailsQueryVariablesGQLType>(ImplementationDetailsDocumentGQLType, options);
        }
export type ImplementationDetailsQueryHookResult = ReturnType<typeof useImplementationDetailsQuery>;
export type ImplementationDetailsLazyQueryGQLTypeHookResult = ReturnType<typeof useImplementationDetailsLazyQueryGQLType>;
export type ImplementationDetailsQueryResultGQLType = Apollo.QueryResult<ImplementationDetailsQueryGQLType, ImplementationDetailsQueryVariablesGQLType>;
export const UpdateImplementationNameDocumentGQLType = gql`
    mutation updateImplementationName($implementationId: UUID!, $name: String!) {
  updateImplementationName(implementationId: $implementationId, name: $name) {
    id
    name
  }
}
    `;
export type UpdateImplementationNameMutationFnGQLType = Apollo.MutationFunction<UpdateImplementationNameMutationGQLType, UpdateImplementationNameMutationVariablesGQLType>;

/**
 * __useUpdateImplementationNameMutation__
 *
 * To run a mutation, you first call `useUpdateImplementationNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImplementationNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImplementationNameMutation, { data, loading, error }] = useUpdateImplementationNameMutation({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateImplementationNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImplementationNameMutationGQLType, UpdateImplementationNameMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImplementationNameMutationGQLType, UpdateImplementationNameMutationVariablesGQLType>(UpdateImplementationNameDocumentGQLType, options);
      }
export type UpdateImplementationNameMutationHookResult = ReturnType<typeof useUpdateImplementationNameMutation>;
export type UpdateImplementationNameMutationResultGQLType = Apollo.MutationResult<UpdateImplementationNameMutationGQLType>;
export type UpdateImplementationNameMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateImplementationNameMutationGQLType, UpdateImplementationNameMutationVariablesGQLType>;